<template>
    <modal-component
      :active="active"
      @cancel="close"
      @hdlOnClick="addContractualDocument"
      textSave="Guardar"
      titleModal="Agregar nuevo documento"
      :disabled="loading"
      :loader="loading"
    >
      <div class="columns is-multiline is-centered">
        <div class="column is-8">
          <div class="field">
            <label class="label">Nombre <span class="is-mandatory">*</span></label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Nombre"
                v-model="name"
                name="name"
                v-validate="'required'"
                data-vv-as="nombre"
                :class="{'is-danger': vverrors.has('name')}"
                data-testid="field-name"
              >
              <p class="is-error"> {{vverrors.first('name')}} </p>
            </div>
          </div>
        </div>
        <div class="column is-8">
          <div class="field">
            <label class="label">Producto <span class="is-mandatory">*</span></label>
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="{'is-danger': vverrors.has('product'), 'is-loading': isProductsLoading}"
              >
                <select
                  v-model="productId"
                  v-validate="'required'"
                  data-vv-as="producto"
                  name="product"
                >
                  <option :value="null" disabled>Seleccione una opción</option>
                  <option v-for="product in products" :key="product.id" :value="product.id">{{ product.name }}</option>
                </select>
              </div>
              <p class="is-error"> {{vverrors.first('product')}} </p>
            </div>
          </div>
        </div>
        <div class="column is-8">
          <div class="field">
            <label class="label">Régimen</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="regime">
                  <option :value="null" disabled>Todos</option>
                  <option value="PF">Persona física</option>
                  <option value="PFAE">Persona física con actividad empresarial</option>
                  <option value="PM">Persona moral</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-8">
          <div class="field">
            <label class="label">Categoría del documento <span class="is-mandatory">*</span></label>
            <div class="control">
              <div
                class="select is-fullwidth"
                :class="{'is-danger': vverrors.has('documentType'), 'is-loading': isDocumentTypeLoading}"
              >
                <select
                  v-model="documentType"
                  v-validate="'required'"
                  data-vv-as="categoría del documento"
                  name="documentType"
                >
                  <option :value="null" disabled>Seleccione una opción</option>
                  <option v-for="document in documentTypes" :key="document.id" :value="document.code">{{ $t(`documentsTemplateType.${document.code}`, systemConfiguration.lang) }}</option>
                </select>
              </div>
              <p class="is-error"> {{vverrors.first('documentType')}} </p>
            </div>
          </div>
        </div>
      </div>
    </modal-component>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      detault: () => {}
    },
    reload: {
      type: Function,
      detault: () => {}
    }
  },
  data () {
    return {
      loading: false,
      name: null,
      productId: null,
      documentType: null,
      regime: null,
      products: [],
      isProductsLoading: true,
      isDocumentTypeLoading: true,
      documentTypes: []
    }
  },
  mounted () {
    this.getProducts({
      pageNumber: 0,
      perPage: 50
    }).then(({ products }) => {
      if (products) {
        this.products = products
        this.isProductsLoading = false
      }
    })
    this.getDocumentTypeCatalogs().then((documentTypes) => {
      if (documentTypes) {
        this.documentTypes = documentTypes
        this.isDocumentTypeLoading = false
      }
    })
  },
  methods: {
    ...mapActions(['saveContractualDocument', 'getProducts', 'getDocumentTypeCatalogs']),
    async addContractualDocument () {
      if (await this.$validator.validateAll()) {
        this.loading = true
        const response = await this.saveContractualDocument({
          name: this.name,
          productId: this.productId,
          documentType: this.documentType,
          regime: this.regime
        })
        if (response.success) {
          await this.reload()
          this.close()
        }
      }
      this.loading = false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  }
}
</script>
